export function nameToSlug(name) {
  if (!name) return "";
  return name.toLowerCase()
    .replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/[\s_]+/g, "-")
    .slice(0, 80);
}

export function applyAffiliateLink(url, rules) {
  if (!url || !rules?.length) return url;
  try {
    const parsed = new URL(url);
    const domain = parsed.hostname.replace(/^www\./, "");
    for (const rule of rules) {
      if (!rule.is_active) continue;
      const pattern = (rule.domain_pattern || "").replace(/^www\./, "");
      if (domain === pattern || domain.endsWith("." + pattern)) {
        if (rule.param_key && rule.param_value) {
          parsed.searchParams.set(rule.param_key, rule.param_value);
          return parsed.toString();
        }
      }
    }
  } catch {
    return url;
  }
  return url;
}

export function getSpotifyEmbedUrl(spotifyUrl) {
  if (!spotifyUrl?.includes("spotify.com")) return null;
  // Handle intl-* locale prefix and ?si= tracking params
  const clean = spotifyUrl.replace(/\/intl-[a-z-]+\//i, '/').split('?')[0];
  const match = clean.match(/spotify\.com\/(track|album|playlist|episode)\/([a-zA-Z0-9]+)/);
  if (match) {
    return `https://open.spotify.com/embed/${match[1]}/${match[2]}?utm_source=generator&theme=0`;
  }
  return null;
}

export function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const [year, month, day] = dateStr.split("-");
    const months = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"];
    return `${parseInt(day)}. ${months[parseInt(month) - 1]} ${year}`;
  } catch {
    return dateStr;
  }
}

export function formatDateDE(dateStr) {
  if (!dateStr) return "–";
  try {
    const [year, month, day] = dateStr.split("-");
    return `${day}.${month}.${year}`;
  } catch {
    return dateStr;
  }
}

export function getYear(dateStr) {
  return dateStr?.split("-")[0] || "";
}
